module.exports = ".wrapperPanel {\n  margin: 5px; }\n  .wrapperPanel .blueHeader {\n    height: 50px;\n    background-color: blueviolet;\n    width: 100%;\n    text-align: center; }\n  .wrapperPanel .blueHeader h1 {\n      color: aliceblue; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/StartApp/welcome/start/simulator/panel-wrapper/panel-wrapper.component.scss
// module id = ./src/app/StartApp/welcome/start/simulator/panel-wrapper/panel-wrapper.component.scss
// module chunks = main